import React from 'react'
import PropTypes from 'prop-types'
import { Button } from '@mui/material'

import { useTranslation } from 'shared/hooks/useSafeTranslation'
import useStyle from 'shared/hooks/useStyle'
import PictureLayout from 'shared/PictureLayout/PictureLayout'
import styles from './AcceptPicture.style'

const propTypes = {
    image: PropTypes.string.isRequired,
    onAccept: PropTypes.func.isRequired,
    onReject: PropTypes.func.isRequired,
    isRequired: PropTypes.bool.isRequired,
    isNested: PropTypes.bool,
}

const AcceptPicture = ({
    image,
    onAccept,
    onReject,
    isRequired,
    isNested = false,
}) => {
    const { t } = useTranslation()
    const classes = useStyle(styles)

    return (
        <PictureLayout
            title={t('PICTURE_OK')}
            image={image}
            isRequired={isRequired}
            isAnswered={false}
            isNested={isNested}
        >
            <>
                <Button
                    data-testid="no-button"
                    css={classes.button}
                    onClick={onReject}
                >
                    {t('NO')}
                </Button>
                <Button
                    data-testid="yes-button"
                    css={classes.button}
                    onClick={onAccept}
                >
                    {t('YES')}
                </Button>
            </>
        </PictureLayout>
    )
}

AcceptPicture.propTypes = propTypes

export default AcceptPicture
